import React, {useContext, useEffect, useState} from "react";
import {AppContext} from "./../context/AppContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from "jquery";
import {Link} from "react-router-dom";
import Form from "react-bootstrap/Form";

import ic_delete from "../assets/images/ic_delete.svg";
import ic_edit from "../assets/images/ic_edit.svg";
import ic_eyes from "../assets/images/ic_eyes.svg";
import Modal from "react-bootstrap/Modal";
import ApiConfig from "../api/ApiConfig";
import {getWithAuthCallWithErrorResponse, simpleGetCall, simplePostCall} from "../api/ApiServices";
import {Table} from "react-bootstrap";
import Loading from "../sharedComponents/Loaders/Loading";
import {Pagination} from "./Pagination";
import swal from "sweetalert";

const Order = () => {
    const {sidebar, setCount, count} = useContext(AppContext);
    const [currentPage, setCurrentPage] = useState(0);
    const startIndex = currentPage * 15;
    const endIndex = startIndex + 15;
    const changePage = ({selected}) => {
        setCurrentPage(selected);
    };

    // Search func()ty state
    const [searchInput, setSearchInput] = useState("");

    const handleSearchInputChange = (e) => {
        console.log("CUs Name", e.target.value)
        setSearchInput(e.target.value);
    };

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [deleteId, setDeleteId] = useState("")
    const [deleteShow, setDeleteShow] = useState(false);
    const handleDeleteClose = () => setDeleteShow(false);
    const handleDeleteShow = (orderId) => {
        console.log("orderId", orderId)
        setDeleteId(orderId)
        setDeleteShow(true);
    }

    const [viewShow, setViewShow] = useState(false);
    const handleViewClose = () => setViewShow(false);
    const handleViewShow = (order) => {
        setViewShow(true);
        setSelectedOrderId(order.orderId);
    };
    const [vendingMachineList, setVendingMachineList] = useState([]);

    const deleteTrData = () => {
        simplePostCall(`${ApiConfig.DELETE_ORDER_BY_ID}?OrderId=${deleteId}`)
            .then((res) => {
                console.log("Deleted tr sucess", deleteId);
                setDeleteShow(false);
                getOrderList()
            })
            .catch((err) => {
                console.log("Err", err)
            })
    }

    const [validated, setValidated] = useState(false);
    const [orderList, setOrderList] = useState([]);
    const [orderDetailsById, setOrderDetailsById] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const [selectedOrderId, setSelectedOrderId] = useState("");
    const months = [
        {value: "0", label: "All"},
        {value: "1", label: "January"},
        {value: "2", label: "Febuary"},
        {value: "3", label: "March"},
        {value: "4", label: "April"},
        {value: "5", label: "May"},
        {value: "6", label: "June"},
        {value: "7", label: "July"},
        {value: "8", label: "August"},
        {value: "9", label: "September"},
        {value: "10", label: "October"},
        {value: "11", label: "November"},
        {value: "12", label: "December"},
    ];

    const years = [
        {value: "2025", label: "2025"},
        {value: "2024", label: "2024"},
    ];

    const shippingStatuses = [
        {value: 0, label: "N/A"},
        {value: 1, label: "Your Order is Being Packed for Shipping"},
        {value: 2, label: "Your Order Has Been Shipped"}
    ];

    const pickupStatuses = [
        {value: 0, label: "N/A"},
        {value: 1, label: "Order Ready for Pickup at Vending Machine"},
        {value: 2, label: "Order Released/Product Dispensed"}
    ];

    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
    const [selectedVendingMachine, setSelectedVendingMachine] = useState('');
    const [selectedYear, setSelectedYear] = useState(years[0].value);
    const [dataUpdateOrderStatus, setDataUpdateOrderStatus] = useState({
        OrderID: null,
        OrderStatus: "",
        TrackingUrl: "",
        TrackingNumber: "",
        ShippingStatus: 0,
        PickupStatus: 0,
        VendingMachineLogged: false,
        OrderCompleted: false
    });
    const getOrderList = () => {
        setIsLoading(true);
        let apiUrl = ApiConfig.ORDER_LIST + `${selectedMonth}&Year=${selectedYear}`;
        if (selectedVendingMachine) {
            apiUrl += `&MachineId=${selectedVendingMachine}`;
        }
        getWithAuthCallWithErrorResponse(apiUrl)
            .then((res) => {
                // console.log(res);
                let data = res.json;

                if (data) {
                    setOrderList(data.data);
                    setIsLoading(false);
                }
            })

            .catch((err) => {
                setIsLoading(false);
                console.log(err);
            });
    };
    const getOrderDetailsById = () => {
        setIsLoading(true);
        getWithAuthCallWithErrorResponse(
            ApiConfig.ORDER_DETAILS_BY_ID + "/" + selectedOrderId
        )
            .then((res) => {
                console.log(res, 'getOrderDetailsById');
                let data = res.json;
                if (data.success) {
                    setOrderDetailsById(data.data);
                    setIsLoading(false);
                    let order = data.data;
                    setDataUpdateOrderStatus({
                        OrderID: order.orderId,
                        OrderStatus: order.orderStatus,
                        TrackingUrl: order.trackingUrl ? order.trackingUrl : '',
                        TrackingNumber: order.trackingNumber ? order.trackingNumber : '',
                        ShippingStatus: order.shippingStatus,
                        PickupStatus: order.pickupStatus,
                        VendingMachineLogged: order.vendingMachineLogged,
                        OrderCompleted: order.orderCompleted
                    });
                }
            })

            .catch((err) => {
                setIsLoading(false);
                console.log(err);
            });
    };
    const handleSubmit = (event) => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }

        setValidated(true);
    };

    useEffect(() => {
        getOrderList();
        if (selectedOrderId) {
            getOrderDetailsById();
        }
        getAllVendingMachineList();
    }, [selectedOrderId]);

    const handleReset = () => {
        setSelectedMonth(new Date().getMonth() + 1);
        setSelectedYear(years[0].value);
        getOrderList();
    };

    const getAllVendingMachineList = () => {
        simpleGetCall(ApiConfig.GET_ALL_VENDING_MACHINE + `?&size=1000`)
            .then((res) => {
                if (res.result === true) {
                    setVendingMachineList(res.vendingMachineList || []);
                } else {
                    setVendingMachineList([]);
                    console.log("error response", res);
                }
            })
            .catch((error) => {
                console.log("catch error response,", error);
                setVendingMachineList([]);
            });
    };

    const updateOrderStatus = (shippingStatus = null, pickupStatus = null, vendingMachineLogged = null, orderCompleted = null) => {
        setIsLoading(true);
        let reqBody = JSON.stringify({
            OrderID: Number(dataUpdateOrderStatus.OrderID),
            OrderStatus: dataUpdateOrderStatus.OrderStatus,
            TrackingUrl: dataUpdateOrderStatus.TrackingUrl ? dataUpdateOrderStatus.TrackingUrl : '',
            TrackingNumber: dataUpdateOrderStatus.TrackingNumber ? dataUpdateOrderStatus.TrackingNumber : '',
            ShippingStatus: shippingStatus !== null ? Number(shippingStatus) : Number(orderDetailsById.shippingStatus),
            PickupStatus: pickupStatus !== null ? Number(pickupStatus) : Number(orderDetailsById.pickupStatus),
            VendingMachineLogged: vendingMachineLogged !== null ? vendingMachineLogged : dataUpdateOrderStatus.VendingMachineLogged,
            OrderCompleted: orderCompleted !== null ? orderCompleted : dataUpdateOrderStatus.OrderCompleted,
        });

        simplePostCall(ApiConfig.UPDATE_ORDER_STATUS, reqBody)
            .then((res) => {
                setIsLoading(false);
                if (res.result) {
                    getOrderList();
                    swal({
                        text: res.message, icon: "success", timer: 2000, dangerMode: false,
                    });
                } else {
                    swal({
                        text: res.message, icon: "error", timer: 2000, dangerMode: false,
                    });
                }
            })
            .catch((err) => {
                setIsLoading(false);
                console.log(err);
            });
    }

    function renderStatusLabel(inputStatus, statuses) {
        const status = statuses.find(status => status.value === Number(inputStatus));
        return status ? status.label : "N/A";
    }

    const calculatePriceAfterDiscount = (orderDetail) => {
        if (!orderDetail?.price) return "NA";
        const price = orderDetail.price;
        const rewardsDiscount = orderDetail.rewards_discount || 0;
        const couponDiscount = orderDetail.coupon_discount || 0;
        return price - rewardsDiscount - couponDiscount;
    };

    return (
        <main
            id="cx-main"
            className={sidebar ? "admin-main" : "cx-active admin-main"}
        >
            <div className="heading-btn-main">
                <div className="heading-common">
                    <label htmlFor="">ORDERS</label>
                </div>
                <div className="add-btn"></div>
            </div>

            <Modal
                show={show}
                onHide={handleClose}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>USER ID CARD VERIFICATION</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row user-detail">
                        <div className="col-3 ">
                            <label htmlFor="">Full Name:</label>
                        </div>
                        <div className="col-3 ">
                            <span>Ramakant </span>
                        </div>
                    </div>

                    <div className="row user-detail">
                        <div className="col-3 ">
                            <label htmlFor="">Email :</label>
                        </div>
                        <div className="col-3 ">
                            <span>ramakant@gmail.com </span>
                        </div>
                    </div>

                    <div className="row user-detail">
                        <div className="col-3 ">
                            <label htmlFor="">Date of Birth :</label>
                        </div>
                        <div className="col-3 ">
                            <span>29-Dec-2022 </span>
                        </div>
                    </div>
                    <div className="row user-detail">
                        <div className="col-3 ">
                            <label htmlFor="">ID Card :</label>
                        </div>
                        <div className="col-3 ">
                            <span>NA </span>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="buttons-modal    ">
                        <button className="me-2 " type="submit" onClick={handleClose}>
                            Cancel
                        </button>
                        <button className=" " type="submit">
                            Verify User
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal
                show={viewShow}
                onHide={handleViewClose}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>ORDER DETAILS</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="row user-detail">
                        <div className="col-md-3 ">
                            <label htmlFor="">Customer Name :</label>
                        </div>
                        <div className="col-md-9 ">
              <span>
                {orderDetailsById?.customerName
                    ? orderDetailsById?.customerName
                    : "NA"}{" "}
              </span>
                        </div>
                    </div>

                    <div className="row user-detail">
                        <div className="col-md-3 ">
                            <label htmlFor="">Email :</label>
                        </div>
                        <div className="col-md-9 ">
              <span>
                {orderDetailsById?.email ? orderDetailsById?.email : "NA"}{" "}
              </span>
                        </div>
                    </div>

                    <div className="row user-detail">
                        <div className="col-md-3 ">
                            <label htmlFor="">Phone Number :</label>
                        </div>
                        <div className="col-md-9 ">
              <span>
                {orderDetailsById?.phoneNumber
                    ? orderDetailsById?.phoneNumber
                    : "NA"}
              </span>
                        </div>
                    </div>
                    <div className="row user-detail">
                        <div className="col-md-3 ">
                            <label htmlFor="">Order Status :</label>
                        </div>
                        <div className="col-md-9 ">
              <span>
                {orderDetailsById?.orderStatus
                    ? orderDetailsById?.orderStatus
                    : "NA"}
              </span>
                        </div>
                    </div>
                    <div className="row user-detail">
                        <div className="col-md-3 ">
                            <label htmlFor="">Address :</label>
                        </div>
                        <div className="col-md-9 ">
                            <p>
                                {orderDetailsById?.address ? orderDetailsById?.address : "NA"}
                            </p>
                        </div>
                    </div>
                    <div className="row user-detail">
                        <div className="col-md-3 ">
                            <label htmlFor="">City :</label>
                        </div>
                        <div className="col-md-9 ">
              <span>
                {orderDetailsById?.city ? orderDetailsById?.city : "NA"}
              </span>
                        </div>
                    </div>
                    <div className="row user-detail">
                        <div className="col-md-3 ">
                            <label htmlFor="">Zip Code :</label>
                        </div>
                        <div className="col-md-9 ">
              <span>
                {orderDetailsById?.zipCode ? orderDetailsById?.zipCode : "NA"}
              </span>
                        </div>
                    </div>
                    <div className="row user-detail">
                        <div className="col-md-3 ">
                            <label htmlFor="">Pickup Code :</label>
                        </div>
                        <div className="col-md-9 ">
              <span>
                {orderDetailsById?.pickupCode ? orderDetailsById?.pickupCode : "NA"}
              </span>
                        </div>
                    </div>
                    <div className="row user-detail">
                        <div className="col-md-3 ">
                            <label htmlFor="">Machine ID :</label>
                        </div>
                        <div className="col-md-9 ">
              <span>
                {orderDetailsById?.machine_id ? orderDetailsById?.machine_id : "NA"}
              </span>
                        </div>
                    </div>
                    <div className="row user-detail">
                        <div className="col-md-3 ">
                            <label htmlFor="">Machine Name :</label>
                        </div>
                        <div className="col-md-9 ">
              <span>
                {orderDetailsById?.machine_name ? orderDetailsById?.machine_name : "NA"}
              </span>
                        </div>
                    </div>
                    <div className="row user-detail">
                        <div className="col-md-3 ">
                            <label htmlFor="">Machine Location :</label>
                        </div>
                        <div className="col-md-9 ">
              <span>
                {orderDetailsById?.machine_address ? orderDetailsById?.machine_address : "NA"}
              </span>
                        </div>
                    </div>
                    <div className="row user-detail">
                        <div className="col-md-3 ">
                            <label htmlFor="">Order ID :</label>
                        </div>
                        <div className="col-md-9 ">
              <span>
                {orderDetailsById?.orderId ? orderDetailsById?.orderId : "NA"}{" "}
              </span>
                        </div>
                    </div>
                    <div className="row user-detail">
                        <div className="col-md-3 ">
                            <label htmlFor="">Total Products :</label>
                        </div>
                        <div className="col-md-9 ">
              <span>
                {orderDetailsById?.totalProducts
                    ? orderDetailsById?.totalProducts
                    : "NA"}
              </span>
                        </div>
                    </div>
                    <div className="row user-detail">
                        <div className="col-md-3 ">
                            <label htmlFor="">Reward Discount :</label>
                        </div>
                        <div className="col-md-9 ">
              <span>
                {orderDetailsById?.rewards_discount ? orderDetailsById?.rewards_discount : 0}
              </span>
                        </div>
                    </div>
                    <div className="row user-detail">
                        <div className="col-md-3 ">
                            <label htmlFor="">Coupon Discount :</label>
                        </div>
                        <div className="col-md-9 ">
                <span>
                  {orderDetailsById?.coupon_discount ? orderDetailsById?.coupon_discount : 0}
                </span>
                        </div>
                    </div>
                    <div className="row user-detail">
                        <div className="col-md-3 ">
                            <label htmlFor="">Price :</label>
                        </div>
                        <div className="col-md-9 ">
              <span>
                {orderDetailsById?.price ? orderDetailsById?.price : "NA"}
              </span>
                        </div>
                    </div>
                    <div className="row user-detail">
                        <div className="col-md-3 ">
                            <label htmlFor="">Price After Discount :</label>
                        </div>
                        <div className="col-md-9 ">
              <span>
                {calculatePriceAfterDiscount(orderDetailsById)}
              </span>
                        </div>
                    </div>
                    <div className="row user-detail">
                        <div className="col-md-3 ">
                            <label htmlFor="">Date and Time :</label>
                        </div>
                        <div className="col-md-9 ">
              <span>
                {orderDetailsById?.orderDate ? orderDetailsById?.orderDate : "NA"}
              </span>
                        </div>
                    </div>
                    <div className="row user-detail">
                        <div className="col-md-3 ">
                            <label htmlFor="">Shipping Status :</label>
                        </div>
                        <div className="col-md-9 ">
                            <Form.Select
                                value={dataUpdateOrderStatus?.ShippingStatus}
                                onChange={(e) => {
                                    let shippingStatus = e.target.value;
                                    setDataUpdateOrderStatus({
                                        ...dataUpdateOrderStatus,
                                        ShippingStatus: shippingStatus,
                                    });
                                    updateOrderStatus(shippingStatus, null);
                                }}
                                disabled={Number(dataUpdateOrderStatus.PickupStatus) !== 0}
                            >
                                {shippingStatuses.map((status) => (
                                    <option key={status.value} value={status.value}>
                                        {status.label}
                                    </option>
                                ))}
                            </Form.Select>
                        </div>
                    </div>
                    <div className="row user-detail">
                        <div className="col-md-3 ">
                            <label htmlFor="">Shipping Tracking Number :</label>
                        </div>
                        <div className="col-md-9 ">
                            <Form.Control
                                type="text"
                                value={dataUpdateOrderStatus?.TrackingNumber}
                                onChange={(e) => {
                                    setDataUpdateOrderStatus({
                                        ...dataUpdateOrderStatus,
                                        TrackingNumber: e.target.value,
                                    });
                                }}
                                onBlur={(e) => {
                                    if (dataUpdateOrderStatus.TrackingNumber !== e.target.value) {
                                        updateOrderStatus(null, null);
                                    }
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" && dataUpdateOrderStatus.TrackingNumber !== e.target.value) {
                                        updateOrderStatus(null, null);
                                    }
                                }}
                                disabled={Number(dataUpdateOrderStatus.PickupStatus) !== 0}
                            />
                        </div>
                    </div>
                    <div className="row user-detail">
                        <div className="col-md-3 ">
                            <label htmlFor="">Shipping Tracking Link :</label>
                        </div>
                        <div className="col-md-9 ">
                            <Form.Control
                                type="text"
                                value={dataUpdateOrderStatus?.TrackingUrl}
                                onChange={(e) => {
                                    setDataUpdateOrderStatus({
                                        ...dataUpdateOrderStatus,
                                        TrackingUrl: e.target.value,
                                    });
                                }}
                                onBlur={(e) => {
                                    if (dataUpdateOrderStatus.PickupStatus !== e.target.value) {
                                        updateOrderStatus(null, null);
                                    }
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" && dataUpdateOrderStatus.PickupStatus !== e.target.value) {
                                        updateOrderStatus(null, null);
                                    }
                                }}
                                disabled={Number(dataUpdateOrderStatus.PickupStatus) !== 0}
                            />
                        </div>
                    </div>
                    <div className="row user-detail">
                        <div className="col-md-3 ">
                            <label htmlFor="">Pickup Status :</label>
                        </div>
                        <div className="col-md-9 ">
                            <Form.Select
                                value={dataUpdateOrderStatus?.PickupStatus}
                                onChange={(e) => {
                                    let pickupStatus = e.target.value;
                                    setDataUpdateOrderStatus({
                                        ...dataUpdateOrderStatus,
                                        PickupStatus: pickupStatus,
                                    });
                                    updateOrderStatus(null, pickupStatus);
                                }}
                                disabled={Number(dataUpdateOrderStatus.ShippingStatus) !== 0}
                            >
                                {pickupStatuses.map((status) => (
                                    <option key={status.value} value={status.value}>
                                        {status.label}
                                    </option>
                                ))}
                            </Form.Select>
                        </div>
                    </div>
                    <div className="row user-detail">
                        <div className="col-md-3 ">
                            <label htmlFor="">Vending Machine Logged In :</label>
                        </div>
                        <div className="col-md-9 ">
                            <Form.Check
                                type="checkbox"
                                checked={dataUpdateOrderStatus?.VendingMachineLogged}
                                onChange={(e) => {
                                    let vendingMachineLogged = e.target.checked;
                                    setDataUpdateOrderStatus({
                                        ...dataUpdateOrderStatus,
                                        VendingMachineLogged: vendingMachineLogged,
                                    });
                                    updateOrderStatus(null, null, vendingMachineLogged);
                                }}
                                disabled={Number(dataUpdateOrderStatus.ShippingStatus) !== 0}
                            />
                        </div>
                    </div>
                    <div className="row user-detail">
                        <div className="col-md-3 ">
                            <label htmlFor="">Order Completed :</label>
                        </div>
                        <div className="col-md-9 ">
                            <Form.Check
                                type="checkbox"
                                checked={dataUpdateOrderStatus?.OrderCompleted}
                                onChange={(e) => {
                                    let orderCompleted = e.target.checked;
                                    setDataUpdateOrderStatus({
                                        ...dataUpdateOrderStatus,
                                        OrderCompleted: orderCompleted,
                                    });
                                    updateOrderStatus(null, null, null, orderCompleted);
                                }}
                            />
                        </div>
                    </div>
                    <div className="table-user-details">
                        {isLoading ? (
                            <Loading/>
                        ) : (
                            <Table>
                                <thead>
                                <tr className="table-heading">
                                    <th colspan="7">ORDER ITEMS</th>
                                </tr>
                                <tr className="item-heading">
                                    <th>Sr No</th>
                                    <th>Product</th>
                                    <th>Quantity</th>
                                    <th>Package Weight</th>
                                    <th>Package Unit</th>
                                    <th>Price</th>
                                    <th>Added Date & Time</th>
                                </tr>
                                </thead>
                                <tbody>
                                {orderDetailsById?.orderItems?.map((item, index) => {
                                    return (
                                        <tr key={"item" + index}>
                                            <td>{index + 1}</td>
                                            <td>{item?.product ? item?.product : "NA"}</td>
                                            <td>{item?.quantity ? item?.quantity : "NA"}</td>
                                            <td>{item?.packageWt ? item?.packageWt : "NA"}</td>
                                            <td>{item?.packageUnit ? item?.packageUnit : "NA"}</td>
                                            <td>{item?.price ? item?.price : "NA"}</td>
                                            <td>{item?.addedDate ? item?.addedDate : "NA"}</td>
                                        </tr>
                                    );
                                })}
                                </tbody>
                            </Table>
                        )}
                    </div>
                </Modal.Body>
            </Modal>

            <Modal
                show={deleteShow}
                onHide={handleDeleteClose}
                size="sm"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="delete-msg text-center">
                        <label htmlFor="">Do you want to delete?</label>
                    </div>
                </Modal.Body>
                <Modal.Footer className="justify-content-center">
                    <div className="buttons-modal    ">
                        <button
                            className="me-2 "
                            type="submit"
                            style={{backgroundColor: "red"}}
                            onClick={deleteTrData}
                        >
                            Delete
                        </button>
                        <Link to="#" className="" onClick={handleDeleteClose}>
                            Cancel
                        </Link>
                    </div>
                </Modal.Footer>
            </Modal>
            <div className="table-wrapper">
                <div className="row mb-4 order-select-input">
                    <div className="col-md-4">
                        <Form.Label column={"sm"}>Month</Form.Label>
                        <Form.Select value={selectedMonth}
                                     onChange={(e) => {
                                         setSelectedMonth(e.target.value);
                                     }}
                        >
                            {months?.map((month, index) => {
                                return (
                                    <option key={"month" + index} value={month?.value}>
                                        {month?.label}
                                    </option>
                                );
                            })}
                        </Form.Select>
                    </div>
                    <div className="col-md-2">
                        <Form.Label column={"sm"}>Year</Form.Label>
                        <Form.Select
                            value={selectedYear}
                            onChange={(e) => {
                                setSelectedYear(e.target.value);
                            }}
                        >
                            {years?.map((year, index) => {
                                return (
                                    <option key={"year" + index} value={year?.value}>
                                        {year?.label}
                                    </option>
                                );
                            })}
                        </Form.Select>
                    </div>
                    <div className="col-md-4">
                        <Form.Label column={"sm"}>Vending Machine</Form.Label>
                        <Form.Select
                            value={selectedVendingMachine}
                            onChange={(e) => {
                                setSelectedVendingMachine(e.target.value);
                            }}
                        >
                            <option value="">-- Select a Vending Machine --</option>
                            {vendingMachineList?.map((machine, index) => {
                                return (
                                    <option key={"machine" + index} value={machine?.id}>
                                        {machine?.name}
                                    </option>
                                );
                            })}
                        </Form.Select>
                    </div>
                    <div className="col-md-2 mb-1">
                        <button className="ml-2 me-2" type="submit" onClick={getOrderList}>Submit</button>
                        <button type="reset" onClick={handleReset}>Reset</button>
                    </div>
                </div>
                <div className="headerFlex">
                    <div className="innerLabel">
                        <label className="labelTxt">
                            Total Records : {orderList.length}
                        </label>
                    </div>
                    <div className="searchFilter">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search By Name ..."
                            value={searchInput}
                            onChange={handleSearchInputChange}
                        />
                    </div>
                </div>
                {isLoading ? (
                    <Loading/>
                ) : (
                    <Table id="Order" class="table display">
                        <thead>
                        <tr>
                            <th>Sr No.</th>
                            <th>Order Number</th>
                            <th>Customer Name</th>
                            <th>Phone Number</th>
                            <th>Order Status</th>
                            <th>Price</th>
                            <th>Date & Time</th>
                            <th>Shipping Status</th>
                            <th>Pickup Status</th>
                            <th>Order Completed</th>
                            <th>Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        {orderList?.length > 0 &&
                            orderList
                                .filter((item) => {
                                    return item.customerName
                                        .toLowerCase()
                                        .includes(searchInput.toLowerCase());
                                })
                                .slice(startIndex, endIndex)
                                .map((order, index) => {
                                    return (
                                        <tr key={"order" + index}>
                                            <td>{index + 1}</td>
                                            <td>{order?.orderId}</td>
                                            <td>
                                                {order?.customerName}
                                            </td>
                                            <td>{order?.phoneNumber ? order?.phoneNumber : "NULL"}</td>
                                            <td>{order?.orderStatus ? order?.orderStatus : "NULL"}</td>
                                            <td>{order?.price ? order?.price : "NULL"}</td>
                                            <td>{order?.orderDate ? order?.orderDate : "NULL"}</td>
                                            <td>{renderStatusLabel(order?.shippingStatus, shippingStatuses)}</td>
                                            <td>{renderStatusLabel(order?.pickupStatus, pickupStatuses)}</td>
                                            <td>{order?.orderCompleted ? "true" : "false"}</td>
                                            <td className="action">
                                                <Link
                                                    to="#"
                                                    className="icon"
                                                    onClick={() => {
                                                        handleViewShow(order);
                                                    }}
                                                >
                                                    <img src={ic_eyes} alt=""/>
                                                </Link>

                                                <Link to="#" className="icon" onClick={() => {
                                                    handleDeleteShow(order.orderId)
                                                }}>
                                                    <img src={ic_delete} alt=""/>
                                                </Link>
                                            </td>
                                        </tr>
                                    );
                                })
                        }
                        </tbody>
                    </Table>
                )}
                <div className="d-flex justify-content-end">
                    {orderList && orderList.length > 0 ? (
                        <Pagination
                            changePage={changePage}
                            pageCount={orderList?.length / 15}
                            currentPage={currentPage}
                        />
                    ) : (
                        <div>
                            <h5 style={{color: "red"}}> Records Not Found</h5>
                        </div>
                    )}
                </div>
            </div>
        </main>
    );
};

export default Order;
